import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import BeforeAfter from "@/components/BeforeAfter";
import Features from "@/components/Features";
import Timetable from "@/components/Timetable";
import Manifesto from "@/components/Manifesto";
import Pricing from "@/components/Pricing";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    // Smooth anchor scrolling
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -70 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <BeforeAfter />
      <Features />
      <Timetable />
      <Manifesto />
      <Pricing />
      <Footer />
    </div>
  );
}

export default App;
